var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_456_4514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79995 0C5.70741 0 3.19995 2.5066 3.19995 5.60028C3.19995 8.69395 5.70741 11.2006 8.79995 11.2006C11.8925 11.2006 14.4 8.69395 14.4 5.60028C14.4 2.5066 11.8925 0 8.79995 0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 8.00488V11.2068H16V12.8078H19.2V16.0097H20.8V12.8078H24V11.2068H20.8V8.00488H19.2Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.3994H5.6C2.50738 14.3994 0 16.9071 0 20.002V24H17.6V20.002C17.6 16.9071 15.0926 14.3994 12 14.3994Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_456_4514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowers);
export default __webpack_public_path__ + "static/media/followers.166b85a4c3474a76df1cc5879af5b5f4.svg";
export { ForwardRef as ReactComponent };